import { useState } from "react";
import mapMod from "../MapOptionData/mapMod";
import { Alert, Button, TextField, FormControlLabel, Checkbox, Box, Paper, Stack, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function RegexTrans() {
  const [engInput, setEngInput] = useState('');
  const [최종결과, set최종결과] = useState('');
  const [use17T, setUse17T] = useState(false);

  const copyClipBoard = async () => {
    try {
      await navigator.clipboard.writeText(최종결과);
      alert('복사 완료!');
    } catch (error) {
      alert('복사 실패!');
    }
  };

  function trans() {
    const engRegexInput = engInput.trim();

    // 한글 입력 검증
    const inputRegex1 = /[가-힣]/g;
    if(inputRegex1.test(engRegexInput)) {
      alert('영문 정규식 형식에 맞춰서 넣으세요');
      return;
    }

    if(!engRegexInput) {
      alert('정규식을 입력하세요');
      return;
    }

    // 전체 입력에서 양쪽 끝 따옴표 제거 후 분리
    let inputToSplit = engRegexInput;
    // 양쪽 끝이 같은 따옴표로 감싸져 있으면 제거
    if(engRegexInput.length >= 2 &&
       ((engRegexInput[0] === '"' && engRegexInput[engRegexInput.length - 1] === '"') ||
        (engRegexInput[0] === "'" && engRegexInput[engRegexInput.length - 1] === "'"))) {
      inputToSplit = engRegexInput.slice(1, -1);
    }

    // |로 구분하여 각 패턴 분리 (내부 따옴표와 공백 유지)
    const patterns = inputToSplit.split('|').map(p => {
      // 앞뒤 공백만 trim
      let trimmed = p.trim();
      // 양쪽 끝의 따옴표만 제거 (내부 따옴표는 보존)
      let result = trimmed;

      // 첫 글자와 마지막 글자가 같은 따옴표이고, 길이가 2 이상이면 양쪽 끝 따옴표로 간주하여 제거
      if(result.length >= 2 &&
         ((result[0] === '"' && result[result.length - 1] === '"') ||
          (result[0] === "'" && result[result.length - 1] === "'"))) {
        result = result.slice(1, -1);
      }
      // 첫 글자만 따옴표인 경우 (내부 따옴표로 간주하여 보존)
      // 뒤 따옴표만 있는 경우도 보존

      return result;
    }).filter(p => p.length > 0);

    const resultPatterns = [];  // 최종 결과 패턴들

    // 각 패턴 처리
    patterns.forEach(pattern => {
      // ! 체크
      const trimmedForCheck = pattern.trimStart();
      const isExclude = trimmedForCheck.startsWith('!');
      const searchPattern = isExclude ? pattern.replace(/^\s*!/, '') : pattern;

      // $로 끝나면 문자열 끝에 매칭되도록 처리
      const hasEndAnchor = searchPattern.endsWith('$');
      const patternForSearch = hasEndAnchor ? searchPattern.slice(0, -1) : searchPattern;
      // $ 앵커가 있으면 항상 endsWith 사용 (정확한 끝부분 매칭)
      const useEndsWith = hasEndAnchor;

      // mapMod에서 engMod와 engRegex로 검색
      // 여러 개가 검색되면 17T 우선
      let foundItems = mapMod.filter(mod => {
        let lowerEngMod = mod.engMod.toLowerCase();
        const lowerEngRegex = mod.engRegex?.toLowerCase() || '';
        const lowerPattern = patternForSearch.toLowerCase();

        // engMod 검색
        let matchesMod = false;
        if(useEndsWith) {
          // $ 앵커의 경우: 끝부분 매칭 또는 각 줄의 끝에서 매칭
          // 개행 문자로 분리하여 각 줄의 끝 확인
          const lines = lowerEngMod.split('\n');
          const endsWithPattern = lines.some(line => {
            const trimmedLine = line.trim();
            return trimmedLine.endsWith(lowerPattern);
          });
          // 전체 텍스트의 끝도 확인
          matchesMod = endsWithPattern || lowerEngMod.trim().endsWith(lowerPattern);
        } else {
          matchesMod = lowerEngMod.includes(lowerPattern);
        }

        // engRegex 검색
        let matchesRegex = false;
        if(useEndsWith) {
          matchesRegex = lowerEngRegex.endsWith(lowerPattern);
        } else {
          matchesRegex = lowerEngRegex.includes(lowerPattern);
        }

        return matchesMod || matchesRegex;
      });

      if(foundItems.length === 0) {
        // 매칭 없음
        return;
      }

      // 여러 개 검색된 경우 모든 항목의 regex를 수집 (중복 제거)
      const uniqueRegexes = new Set();

      if(use17T) {
        // 17T 항목 우선 수집
        const items17T = foundItems.filter(mod => mod.lv === 17);
        if(items17T.length > 0) {
          items17T.forEach(mod => {
            uniqueRegexes.add(mod.regex);
          });
        } else {
          // 17T 항목이 없으면 모든 항목의 regex 추가
          foundItems.forEach(mod => {
            uniqueRegexes.add(mod.regex);
          });
        }
      } else {
        // 17T 체크박스가 꺼져있으면 17T 제외하고 일반 항목만 수집
        const itemsNormal = foundItems.filter(mod => mod.lv !== 17);
        itemsNormal.forEach(mod => {
          uniqueRegexes.add(mod.regex);
        });
      }

      // 중복 제거된 regex들을 결과에 추가
      // 제외 패턴의 경우 첫 번째 항목에만 ! 붙이고 나머지는 그냥 추가
      const regexArray = Array.from(uniqueRegexes);

      regexArray.forEach((regex, index) => {
        const finalValue = (isExclude && index === 0) ? `!${regex}` : regex;
        resultPatterns.push(finalValue);
      });
    });

    // 전체 결과에서 중복 제거 (순서 유지)
    // 같은 regex가 여러 패턴에서 나오면 첫 번째만 유지
    const seenRegexes = new Set();
    const uniqueResults = [];

    resultPatterns.forEach(item => {
      // ! 제거하고 비교
      const regex = item.startsWith('!') ? item.slice(1) : item;
      if(!seenRegexes.has(regex)) {
        seenRegexes.add(regex);
        uniqueResults.push(item);
      }
    });

    // 결과 조합
    const result = uniqueResults.join('|');
    set최종결과(result);
  }

  return (
    <>
      <Helmet>
        <title>지도 정규식 영한 변환기</title>
        <meta
          name="description"
          content="패스 오브 엑자일(POE) 지도 정규식 영한 변환기. 영문 정규식을 한글 정규식으로 변환해주는 도구입니다. OR 연산(|로 구분된) 정규식 변환을 지원하며, 17T 데이터 우선 적용 옵션을 제공합니다."
        />
        <meta property="og:title" content="지도 정규식 영한 변환기 - POE Regex KR" />
        <meta property="og:description" content="패스 오브 엑자일(POE) 지도 정규식 영한 변환기. 영문 정규식을 한글 정규식으로 변환해주는 도구입니다." />
        <meta property="og:url" content="https://poeregexkr.web.app/trans" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://poeregexkr.web.app/mirror.png" />
      </Helmet>
      <Alert severity="info" sx={{ mt: 2, mb: 2 }}>
        체크박스를 활성화하면 17T 데이터가 우선 적용됩니다.
      </Alert>
      <FormControlLabel
        control={<Checkbox checked={use17T} onChange={(e) => setUse17T(e.target.checked)} />}
        label="17T 정규식 변환 우선 (중복 시 17T 데이터 적용)"
        sx={{ mb: 1 }}
      />
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ xs: 'stretch', sm: 'flex-start' }}>
        <TextField
          className="engRegex"
          label="영문 정규식 입력"
          type="search"
          fullWidth
          value={engInput}
          onChange={(e) => setEngInput(e.target.value)}
        />
        <Button
          variant="contained"
          onClick={trans}
          sx={{ minWidth: { sm: 120 }, height: { sm: 56 } }}
        >
          변환
        </Button>
      </Stack>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>변환된 결과</Typography>
        <Paper
          variant="outlined"
          sx={{
            p: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          <Typography sx={{ fontFamily: 'monospace', fontSize: 16, wordBreak: 'break-all', flex: 1, minWidth: 0 }}>
            {최종결과}
          </Typography>
          <Button variant="contained" color="success" onClick={copyClipBoard}>복사</Button>
        </Paper>
      </Box>

      <Stack spacing={1} sx={{ mt: 3 }}>
        <Typography variant="body2" sx={{ color: 'error.main' }}>
          ※ 주의 !! 버그가 있을 수 있습니다. 최소한 개수 확인은 하십쇼
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ※ 수량, 무리 규모 관련 정규식 변환은 안됩니다.<br />
          　m q로 시작하는건 수량, iz로 시작하는건 규모니까 정규식 검색탭을 이용하십쇼
        </Typography>
        <Typography variant="body2" color="text.secondary">※ 영문 정규식 → 한글 정규식으로 변환만 가능</Typography>
        <Typography variant="body2" color="text.secondary">
          ※ OR연산( |로 구분된 ) 관련 정규식 변환만 처리 가능합니다. (ex : "!mum p|f el|hock$|fra|mmo|f ph")
        </Typography>
        <Typography variant="body2" color="text.secondary">
          오류는 <Link to="/bugreport" style={{ color: 'inherit', fontWeight: 700 }}>버그 제보</Link> 페이지에서 제보해주세요.
        </Typography>
      </Stack>
    </>
  );
}

export default RegexTrans;
